
import { Enums, Helpers } from '@bode-canada/core';
import { StyleSizeType, StyleColorSchemeType } from '@/ui-kit/styles/enums';
import Avatar from '@/ui-kit/components/avatar';
import ExternalLink from '@/ui-kit/components/external-link';
import Icon from '@/ui-kit/components/icon';
import { IconType } from '@/ui-kit/components/icon/enums';
import Typography from '@/ui-kit/components/typography';
import { TypographyType } from '@/ui-kit/components/typography/enums';
import routes from '@/constants/routes';
import { PHONE_NUMBER_REGEXP } from './constants';

const EMPTY_STRING = '';

export default {
  name: 'ListingOwnerContactsHeader',
  components: {
    Avatar,
    ExternalLink,
    Typography,
    Icon,
  },
  props: {
    owners: {
      type: Array,
      required: true,
    },
    additionalHolders: {
      type: Array,
      default: null,
    },
    origin: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
      StyleSizeType,
      StyleColorSchemeType,
      TypographyType,
      IconType,
    };
  },
  computed: {
    primaryOwner() {
      return this.owners[0];
    },
    isBodeListing() {
      return this.origin === Enums.ListingOriginEnum.BODE;
    },
    isTRREBListing() {
      return this.origin === Enums.ListingOriginEnum.REPLIERS_TRREB;
    },
    isBuilderListing() {
      return this.primaryOwner.isBuilder;
    },
    holders() {
      return this.additionalHolders && !this.isBuilderListing
        ? [...this.owners, ...this.additionalHolders]
        : this.owners;
    },
    phones() {
      const usersWithPhone = this.isBodeListing
        ? this.owners.filter(({ isPhoneNumberVisible, phone }) => isPhoneNumberVisible && phone)
        : this.owners.filter(({ phone }) => phone);

      return usersWithPhone.map(({ phone }) => phone);
    },
    avatarsStyles() {
      return {
        gridTemplateColumns: `repeat(${this.holders.length}, 50px)`,
      };
    },
    areMultipleHolders() {
      return this.holders.length > 1;
    },
    copyMessage() {
      const verb = this.areMultipleHolders ? 'are' : 'is';

      return `${verb} selling ${
        this.isBuilderListing || !this.areMultipleHolders ? 'this' : 'their own '
      } home using Bōde.`;
    },
  },
  methods: {
    getSellerFullName(seller) {
      const sellerLastName = !this.isBodeListing ? seller.lastName : EMPTY_STRING;

      return seller.nickName
      || Helpers.StringHelper.joinStrings([
        seller.firstName,
        sellerLastName,
      ], ' ');
    },
    getUserLink(userId) {
      return `${routes.profile}/${userId}`;
    },
    getIsLastHolder(userIndex) {
      return userIndex === this.holders.length - 1;
    },
    formatPhoneNumber(input) {
      return input.replace(PHONE_NUMBER_REGEXP, '($1) $2-$3');
    },
    handleSellerProfileLinkClick() {
      this.$emit('sellerProfileLinkClick');
    },
    getIsUserTitleAssociate(title) {
      const REALTOR_TITLE = 'Associate';

      return title === REALTOR_TITLE;
    },
  },
};
